import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { InwardEndToEndSlaTrendService } from "./service/inward-end-to-end-sla-trend.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import { LocalStorageService } from "../../../../shared/services/local-storage.service";
import { BroadcasterService } from "../../../../core/services/broadcaster.service";
import * as HSET from "./settings";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Params } from "@angular/router";
import { CommonService } from "../../../../shared/services";
addMore(Highcharts);
@Component({
  selector: "widget-inward-end-to-end-sla-trend",
  templateUrl: "./widget-inward-end-to-end-sla-trend.component.html",
  styleUrls: ["./widget-inward-end-to-end-sla-trend.component.scss"],
  providers: [InwardEndToEndSlaTrendService]
})
export class WidgetInwardEndToEndSlaTrendComponent
  implements OnInit, OnChanges, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  @Input() FILTERS;
  @Input() OPTIONS;
  widgetId = 12;

  highcharts: typeof Highcharts = Highcharts;
  chartOptions = HSET.chartData;
  errorMessage = "";
  mockChart = null;
  loadingChart = true;
  constructor(
    private translateService: TranslateService,
    private dataService: InwardEndToEndSlaTrendService,
    private broadcaster: BroadcasterService,
    private localStorageService: LocalStorageService,
    private commonService: CommonService,
    private activateRoute: ActivatedRoute
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
      JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
     
    }
  }

  ngOnInit() {
    const intiFilter = JSON.parse(JSON.stringify(this.FILTERS))
    this.translateService
      .get("PERFORMANCE.TRANSFER.REASON_FOR_FAILURE")
      .pipe(takeUntil(this.unsubscribe)).subscribe(text => {
        this.OPTIONS.title = this.OPTIONS.title || text;
      });
    this.broadcaster.listen("PAGE_WIDGET_DATA")
      .pipe(takeUntil(this.unsubscribe)).subscribe(() => {
        this.setWidgetData();
      });
      this.activateRoute.queryParams.pipe(takeUntil(this.unsubscribe)).subscribe((params: Params) => {
        if (Object.keys(params).length) {
          this.FILTERS = this.commonService.getFiltersParams(params, this.FILTERS);
          this.getTransferEndToEndSlaTrendData();
        } else {
          this.FILTERS=JSON.parse(JSON.stringify(intiFilter));
          this.getTransferEndToEndSlaTrendData();
        }
      })
    
  }
  setWidgetData() {
    const pageData = this.localStorageService.getItem("PAGE_WIDGET_DATA");
    if (pageData) {
      pageData.forEach(element => {
        if (element.widget_id === this.widgetId) {
          this.setTarget(element.target);
        }
      });
    }
  }

  setTarget(t) {
    if (this.chartOptions) {
      this.chartOptions.series[2].data = [];
      for (let i = 0; i < this.chartOptions.series[0].data.length; i++) {
        this.chartOptions.series[2].data.push(t);
      }
    }
  }

  getTransferEndToEndSlaTrendData() {
    this.errorMessage = "";
    this.mockChart = null;
    this.loadingChart = true;
    this.dataService
      .getTransferEndToEndSlaTrendData(this.OPTIONS.api, this.FILTERS)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        chartData => {
          if (chartData.volume.length) {
            this.loadingChart = false;

            this.chartOptions = this.dataService.createChart(
              chartData,
              this.OPTIONS
            );
            this.setWidgetData();
          } else {
            this.loadingChart = true;

            this.errorMessage = "ERROR_MSG.NO_DATA";
            this.mockChart = HSET.chartData;
          }
        },
        err => {
          this.loadingChart = true;

          this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
          this.mockChart = HSET.chartData;
        }
      );
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
